import { motion } from "framer-motion";

interface LogoProps {
  className?: string;
  animated?: boolean;
}

export function Logo({ className = "", animated = true }: LogoProps) {
  const logoContent = (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/logo.png" 
        alt="Sharpcut Logo" 
        className="h-10 w-auto object-contain"
      />
    </div>
  );

  if (animated) {
    return (
      <motion.div
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
      >
        {logoContent}
      </motion.div>
    );
  }

  return logoContent;
} 